import { MetadataUpdateType } from '@scale/shared/nucleus/types';
import { CompassCardUI } from '@scale/compass-ui/types';
import {
  UpdateMetadataCardShared,
  UpdateMetadataSchemaType,
  UPDATE_METADATA,
} from '@scale/genai-compass-shared/cards/update_metadata';
import { faTags } from '@fortawesome/pro-solid-svg-icons';
import UpdateMetadataCardComponent from 'react-scale/corp/views/DataCompassCardsV2/action/UpdateMetadataCard/UpdateMetadataCardComponent';

export const UpdateMetadataCardInput: CompassCardUI<UpdateMetadataSchemaType> = {
  ...UpdateMetadataCardShared,
  title: 'Update Metadata',
  icon: 'edit',
  toolTip: 'Update metadata for tasks',
  defaultContext: {
    cardType: UPDATE_METADATA,
    columns: [],
    updateType: MetadataUpdateType.REPLACE,
  },
  ownerTeam: 'Chat Task',
  button: {
    icon: faTags,
  },
  legacyComponent: UpdateMetadataCardComponent,
};
